import { EPosition } from 'constants/enums';

import { StoreThemeFormValues } from './storeTheme.types';

export const defaultStoreTheme: StoreThemeFormValues = {
  defaultBanner: '',
  bundleSections: [],
  promotionSections: [],
  tabs: [],
  buttonColor: {
    colorOne: '#7122ff',
    colorTwo: ''
  },
  buttonTextColor: 'white',
  addToHomeScreen: {
    active: false,
    verticalOffset: 0,
    buttonImage: '',
    iconImage: 'https://media.appcharge.com/defaults/default-store-logo.svg',
    shortcutName: 'Royal Blast Store',
    borderColor: {
      colorOne: '#ffffff'
    },
    backgroundColor: {
      colorOne: '#522AD8',
      colorTwo: ''
    }
  },
  backToGameButton: {
    active: false,
    buttonImage: '',
    position: EPosition.LEFT
  },
  header: {
    backgroundOpacity: 40,
    showLogo: true,
    showPlayerName: true,
    isSticky: false
  },
  noOffersTitleText: 'No Offers Available',
  noOffersMessageText: 'No offers are available at the moment. Try again soon!',
  bundleBorderColor: {
    colorOne: '#e3d3ff',
    colorTwo: ''
  },
  defaultPlayerImage: 'https://media.appcharge.com/defaults/old-profile.png',
  richText: {
    text: '',
    fontColor: 'rgb(0, 0, 0)'
  },
  seo: {
    title: '',
    description: '',
    keywords: [],
    socialShareImageUrl: '',
    socialTitle: '',
    socialDescription: ''
  }
};
